import  NetworkHandler from 'utils/network';
import config from 'config';

function getStaffDetail(id) {
    return NetworkHandler.get(`${config.getUrl('bus_staff')}/${id}`);
}

export default {
    getStaffDetail,
};